import Modal from '@src/common/Modal';
import React,{ useEffect, useState } from 'react';
import FullPageLoader from '@common/FullPageLoader';
import { useLanguage } from '@src/context/LanguageContext';
import timer from "../styles/webroot/images/timer.png";


interface BankDetailModalProps {
    show: boolean;
    handleClose: () => void;
    data?:any,
}

const WaitPopUpModal = ({show,handleClose,data}: BankDetailModalProps) => {

    const [loading, setLoading] = useState(false);
    const {translations} = useLanguage();
     
    useEffect(() => {
        if (show) document.body.classList.add("overflow-hidden");
        return () => {
            document.body.classList.remove("overflow-hidden");
        }
    }, [show])
    return(
        <React.Fragment>
            <FullPageLoader show={loading} /> 
            <div className="model-outer wait-popup-modal">
            <Modal show={show} handleClose={handleClose}>
                <div className="modal-body">
                    <div className="wait-popup-content">
                        <img className="wait-popup-image" src={timer} alt="Please wait" />
                        <span className="wait-popup-text">{translations?.COMMON_MSG?.WAITING_MGS} </span>
                    </div>
                </div>
            </Modal>
            </div>
        </React.Fragment>
    );
}

export default WaitPopUpModal;    
